/**
 * The parts an opened roll-up is drawn with. The class names are the
 * stylesheet's (`drill-sub`, `drill-caret`, …); these components exist so no
 * table spells them by hand. `dt-static` on the header and footer rows keeps
 * the reading cursor: the stylesheet gives every body row a pointer.
 */

/**
 * The caret a roll-up row carries in its first cell, pointing down while its
 * parts are open. An empty one holds the indent on a row with nothing to open,
 * so labels line up down the column whether or not every row expands.
 */
export function DrillCaret({ open, show = true }) {
  return <span className="drill-caret">{show ? (open ? '▾' : '▸') : ''}</span>;
}

/** The column names as they read for the parts, beneath the roll-up's own. */
export function DrillSubhead({ children }) {
  return <tr className="drill-sub drill-subhead dt-static">{children}</tr>;
}

/** One part of an opened roll-up. Takes whatever a `<tr>` takes. */
export function DrillSub({ children, className, ...rest }) {
  return <tr className={className ? `drill-sub ${className}` : 'drill-sub'} {...rest}>{children}</tr>;
}

/**
 * The row that closes an opened group — the show-all control, a note that says
 * what the parts add up to, or both. Spans the whole table.
 */
export function DrillSubfoot({ colSpan, children }) {
  return (
    <tr className="drill-sub drill-subfoot dt-static">
      <td colSpan={colSpan}>{children}</td>
    </tr>
  );
}

/** A sentence under an opened group: what the parts are and what they add to. */
export function DrillNote({ children }) {
  return <div className="drill-note">{children}</div>;
}
